import { useContext, useEffect, useState } from 'react'


/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Grid, MenuItem, Select, Typography, useMediaQuery } from '@mui/material';

import { FaFilter } from "react-icons/fa";
import { ProviderIncomeDashboard } from '../IncomeDashboard';

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

const BarLineChart = ({ keyId, year, title, data,sColor }) => {

    const {
        arrMonth,
        option,
    } = useContext(ProviderIncomeDashboard);
    const matchesUp768 = useMediaQuery('(min-width:768px)');

    const [nDisplay, setnDisplay] = useState(1)

    useEffect(() => {
        let nYearThai = year + 543;

        let ElementId = "chart-museum-" + keyId;
        let chart = am4core.create(ElementId, am4charts.XYChart);
        chart.colors.step = 2;

        chart.zoomOutButton.disabled = true;

        let charttitle = chart.titles.create();
        charttitle.text = " ";
        charttitle.marginBottom = 10;
        charttitle.fontSize = 13;
        charttitle.align = "center";
        charttitle.fontWeight = '400';

        chart.data = data;
        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "sMonth";
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.grid.template.disabled = true;

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "บาท";
        valueAxis.min = 0;
        valueAxis.extraMax = 0.1; 

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "รายได้ปี " + nYearThai;
        columnSeries.dataFields.valueY = "nTotalActual";
        columnSeries.dataFields.categoryX = "sMonth";
        columnSeries.tooltip.label.textAlign = "middle";
        columnSeries.columns.template.fillOpacity = 0.8;
        // columnSeries.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
        columnSeries.columns.template.stroke = am4core.color(sColor); // red outline
        columnSeries.columns.template.fill = am4core.color(sColor); // green fill
        columnSeries.tooltipText = "{categoryX}: [bold]{valueY}[/]";

        function addLine(field, name, isCircle) {
            let lineSeries = chart.series.push(new am4charts.LineSeries());
            lineSeries.name = name;
            lineSeries.dataFields.valueY = field;
            lineSeries.dataFields.categoryX = "sMonth";
            lineSeries.strokeWidth = 3;
            lineSeries.tooltip.label.textAlign = "middle";
            lineSeries.legendSettings.labelText = `[{color}]{name}[/]`;
            lineSeries.tooltipText = "[#fff font-size: 14px]{categoryX} : [/][#fff font-size: 14px]{valueY}[/] [#fff]";

            if (isCircle) {
                let bulletCircle = lineSeries.bullets.push(new am4charts.CircleBullet());
                // bulletCircle.tooltipText = "[#fff font-size: 14px]{categoryX} : [/][#fff font-size: 14px]{valueY}[/] [#fff]";
                let circle = bulletCircle.createChild(am4core.Circle);
                circle.radius = 4;
                circle.strokeWidth = 3;
            }
            else {
                let bulletRegtangle = lineSeries.bullets.push(new am4charts.Bullet());
                // bulletRegtangle.tooltipText = "[#fff font-size: 14px]{categoryX} : [/][#fff font-size: 14px]{valueY}[/] [#fff]";
                let durationRectangle = bulletRegtangle.createChild(am4core.Rectangle);
                bulletRegtangle.horizontalCenter = "middle";
                bulletRegtangle.verticalCenter = "middle";
                bulletRegtangle.width = 7;
                bulletRegtangle.height = 7;
                durationRectangle.width = 7;
                durationRectangle.height = 7;

                let durationState = bulletRegtangle.states.create("hover");
                durationState.properties.scale = 1.2;
            }


        }
        if (nDisplay === 1) {
            addLine("nTotalPlanBeforeYear", "แผนรายได้ปี " + (nYearThai - 1), true);
        }
        else {
            addLine("nTotalPlanAvg3Year", `แผนรายได้เฉลี่ยปี ${nYearThai - 1}-${nYearThai - 3}`, true);
        }
        addLine("nTotalPlanNow", "แผนรายได้ปี " + nYearThai, false);

        chart.legend = new am4charts.Legend();

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.fullWidthLineX = true;
        chart.cursor.xAxis = categoryAxis;
        chart.cursor.lineX.strokeOpacity = 0;
        chart.cursor.lineX.fill = am4core.color("#000");
        chart.cursor.lineX.fillOpacity = 0.1;

        return () => {
            chart.dispose();
        };
    }, [data, keyId, nDisplay, title, year])


    useEffect(() => {

        // Create chart instance
        let chart = null;

        let lstnotNull = data.filter(f => f.nTotalActual != null)
        let hasValue = lstnotNull.findIndex(f => f.nTotalActual !== 0) !== -1;
        
        if (hasValue) {
            chart = am4core.create("chart-museum-donut-" + keyId, am4charts.PieChart3D);
            chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

            let title = chart.titles.create();
            title.text = "รายได้รวม" + title;
            title.fontSize = 16;
            title.align = "center";
            title.fontWeight = '400';

            chart.data = lstnotNull;

            chart.radius = am4core.percent(matchesUp768 ? 50 : 40);
            chart.innerRadius = matchesUp768 ? 60 : 50;

            let series = chart.series.push(new am4charts.PieSeries3D());
            series.dataFields.value = "nTotalActual";
            series.dataFields.category = "sMonth";
            series.labels.template.text = "{sMonth}: {value.percent.formatNumber('#.00')}%";
            series.slices.template.tooltipText = "{sMonth}: {value} ({value.percent.formatNumber('#.00')}%)";

            chart.legend = new am4charts.Legend();
            chart.legend.labels.template.text = "{name}";
            chart.legend.valueLabels.template.text = "";
        }
        else {
            chart = am4core.create("chart-museum-donut-" + keyId, am4charts.PieChart);
            chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

            let title = chart.titles.create();
            title.text = "รายได้รวม" + title;
            title.fontSize = 16;
            title.align = "center";
            title.fontWeight = '400';


            let lsEmpty = [{
                "sMonth": "Dummy",
                "disabled": true,
                "nTotalActual": 1000,
                "color": am4core.color("#dadada"),
                "opacity": 0.3,
                "strokeDasharray": "4,4",
                "tooltip": ""
            }];

            let optionMonth = [
                { label: "มกราคม", value: "1" },
                { label: "กุมภาพันธ์", value: "2" },
                { label: "มีนาคม", value: "3" },
                { label: "เมษายน", value: "4" },
                { label: "พฤภาคม", value: "5" },
                { label: "มิถุนายน", value: "6" },
                { label: "กรกฎาคม", value: "7" },
                { label: "สิงหาคม", value: "8" },
                { label: "กันยายน", value: "9" },
                { label: "ตุลาคม", value: "10" },
                { label: "พฤศจิกายน", value: "11" },
                { label: "ธันวาคม", value: "12" },
            ]

            let lstMeseumSelect = optionMonth.filter(f=>arrMonth.includes(f.value));
            if(lstMeseumSelect.length !== 0){
                lstMeseumSelect.forEach(element => {
                    lsEmpty.push({
                        "sMonth": element.label,
                        "disabled": false,
                        "nTotalActual": 0,
                        "color": am4core.color("#dadada"),
                        "opacity": 0.3,
                        "strokeDasharray": "4,4",
                        "tooltip": element.label,
                    })
                });
            }
            
            chart.data = lsEmpty;

            chart.radius = am4core.percent(matchesUp768 ? 50 : 40);
            chart.innerRadius = 60;

            let series = chart.series.push(new am4charts.PieSeries());
            series.dataFields.value = "nTotalActual";
            series.dataFields.category = "sMonth";
            series.dataFields.hiddenInLegend = "disabled";
            series.labels.template.fontSize = 10;
            series.labels.template.text = "{sMonth}: {value.percent.formatNumber('#.00')}%";
            series.slices.template.tooltipText = "{sMonth}: {value} ({value.percent.formatNumber('#.00')}%)";

            /* Set tup slice appearance */
            let slice = series.slices.template;
            slice.propertyFields.fill = "color";
            slice.propertyFields.fillOpacity = "opacity";
            slice.propertyFields.stroke = "color";
            slice.propertyFields.strokeDasharray = "strokeDasharray";
            slice.propertyFields.tooltipText = "tooltip";

            series.labels.template.propertyFields.disabled = "disabled";
            series.ticks.template.propertyFields.disabled = "disabled";

            /* This creates initial animation */
            series.hiddenState.properties.opacity = 1;
            series.hiddenState.properties.endAngle = -90;
            series.hiddenState.properties.startAngle = -90;
            
        }


        // Cleanup on component unmount
        return () => {
            chart.dispose();
        };
    }, [arrMonth, data, keyId, title])

    return (
        <Grid container spacing={2} justifyContent={"center"}>
            <Grid item xs={12}>
                {/* <Divider>
                    <Chip label={title} size="small" />
                </Divider> */}
                <Typography textAlign={"center"} fontWeight={500} sx={{fontSize:'1.5rem !important'}}>{title}</Typography>
            </Grid>
            <Grid item xs={12} md={7}>
                <div style={{ position: "relative" }}>
                    <div id={"chart-museum-" + keyId} style={{ width: "100%", height: "500px" }}></div>
                    <div style={{ position: 'absolute', top: -8, right: 10, display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FaFilter style={{ fontSize: '1.3em' }} />
                        <Select
                            size="small"
                            autoWidth
                            sx={{
                                height: 30,
                                ".MuiOutlinedInput-notchedOutline > legend": {
                                    width: 0,
                                },
                            }}
                            inputProps={{ "data-testid": "jump-page" }}
                            value={nDisplay}
                            onChange={(e) => {
                                setnDisplay(parseInt(e.target.value + ""))
                            }}
                            MenuProps={{ PaperProps: { sx: { maxHeight: 150 } } }}
                        >
                            <MenuItem value={1}>เทียบแผนรายได้ย้อนหลัง 1 ปี</MenuItem>
                            <MenuItem value={2}>เทียบแผนรายได้เฉลี่ยย้อนหลัง 3 ปี</MenuItem>
                        </Select>
                    </div>
                </div>
            </Grid>
            <Grid item xs={12} md={5}>
                <div id={"chart-museum-donut-" + keyId} style={{ width: "100%", height: "450px" }}></div>
            </Grid>
            <Grid item xs={12} ></Grid>

        </Grid>
    )
}

export default BarLineChart